"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = exports.columnStyleForOffset = exports.columnStyleForSize = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledBaseComponents = require("styled-base-components");

var _styledConfig = require("styled-config");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      flex-basis: 0;\n      flex-grow: 1;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: relative;\n  padding-right: 15px;\n  padding-left: 15px;\n  width: 100%;\n\n  ", "\n  ", "\n\n  @media (min-width: ", ") {\n    ", "\n\n    ", "\n    ", "\n  }\n  @media (min-width: ", ") {\n    ", "\n    ", "\n  }\n  @media (min-width: ", ") {\n    ", "\n    ", "\n  }\n  @media (min-width: ", ") {\n    ", "\n    ", "\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex: 0 0 ", ";\n  max-width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var colums = 12;

var percentage = function percentage(value) {
  return "".concat(100 * value, "%");
};

var columnStyleForSize = function columnStyleForSize(size) {
  return (0, _styledComponents.css)(_templateObject(), percentage(size / colums), percentage(size / colums));
};

exports.columnStyleForSize = columnStyleForSize;

var columnStyleForOffset = function columnStyleForOffset(offset) {
  return (0, _styledComponents.css)(_templateObject2(), percentage(offset / colums));
};

exports.columnStyleForOffset = columnStyleForOffset;

var hasSize = function hasSize(props) {
  return props.xs || props.sm || props.md || props.lg || props.xl;
};

var Column = (0, _styledComponents["default"])(_styledBaseComponents.Div)(_templateObject3(), function (props) {
  return props.xs && columnStyleForSize(props.xs);
}, function (props) {
  return props.xsOffset && columnStyleForOffset(props.xsOffset);
}, function (props) {
  return (0, _styledConfig.getConcreteBreakpointSize)(props, 'sm');
}, function (props) {
  return !hasSize(props) && (0, _styledComponents.css)(_templateObject4());
}, function (props) {
  return props.sm && columnStyleForSize(props.sm);
}, function (props) {
  return props.smOffset && columnStyleForOffset(props.smOffset);
}, function (props) {
  return (0, _styledConfig.getConcreteBreakpointSize)(props, 'md');
}, function (props) {
  return props.md && columnStyleForSize(props.md);
}, function (props) {
  return props.mdOffset && columnStyleForOffset(props.mdOffset);
}, function (props) {
  return (0, _styledConfig.getConcreteBreakpointSize)(props, 'lg');
}, function (props) {
  return props.lg && columnStyleForSize(props.lg);
}, function (props) {
  return props.lgOffset && columnStyleForOffset(props.lgOffset);
}, function (props) {
  return (0, _styledConfig.getConcreteBreakpointSize)(props, 'xl');
}, function (props) {
  return props.xl && columnStyleForSize(props.xl);
}, function (props) {
  return props.xlOffset && columnStyleForOffset(props.xlOffset);
});
exports.Column = Column;
Column.defaultProps = {
  theme: _styledConfig.theme
};